import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../component/Header';
import BackgroundImage from '../images/tirvia/trivia-bg.png'
import SymptomSprint from '../images/tirvia/symptom-sprint.png'
import Mtyh from '../images/tirvia/mtyh.png' 
import HealthCombo from '../images/tirvia/health-combo.png'
import QuicCareTrivia from '../images/tirvia/triviaa.jpg'
import WordSearch from '../images/tirvia/word-search.png'
import BodyPart from '../images/tirvia/body-part.png'
import HealthChain from '../images/tirvia/health-chain.png'
import FirstAid from '../images/tirvia/first-aid.png'

const TriviaGames = () => {
    const [isLoading, setIsLoading] = useState(true);

    // Add 5-second delay before showing content
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 5000);

        return () => clearTimeout(timer);
    }, []);
    const games = [
        {
            id: 1,
            title: 'Symptom Sprint',
            description: 'Choose a list of symptoms and quickly select the most likely associated health condition.',
            image: SymptomSprint, // Add image path later
            link: '/symptom-sprint' // Add link later
        },
        {
            id: 2,
            title: 'Myth or Fact',
            description: 'A fast-paced quiz where users must decide if a health statement is a myth or fact.',
            image: Mtyh,
            link: '/myth-or-fact'
        },
        {
            id: 3,
            title: 'Health Combo Match',
            description: 'Users pair health-related items with their correct benefits.',
            image: HealthCombo,
            link: '/health-combo-match'
        },
        {
            id: 5,
            title: 'Body Part Shuffle',
            description: 'Match body parts to the correct system.',
            image: BodyPart,
            link: '/body-part-shuffle'
        },
        {
            id: 6,
            title: 'Health Chain Reaction',
            description: 'Arrange health actions in the correct order.',
            image: HealthChain,
            link: '/health-chain-reaction'
        },
        {
            id: 7,
            title: 'First Aid Fastlane',
            description: 'Answer first aid scenario questions correctly.',
            image: FirstAid,
            link: '/first-aid-fastlane'
        },
        {
            id: 8,
            title: 'QuickCare Trivia',
            description: 'Race against the clock to ace four rapid-fire QuickCare questions.',
            image: QuicCareTrivia,
            link: '/quickcare-trivia'
        },
        {
            id: 9,
            title: 'Word Search',
            description: 'Players must find hidden health-related words in a grid.',
            image: WordSearch,
            link: '/word-search'
        }
    ];

    if (isLoading) {
        return (
            <div className='w-full flex items-start justify-center bg-[#F9FAFB] relative'>
                <div className='flex flex-col w-full'>
                    <Header title='Trivia Games' />
                    <div 
                        className='min-h-screen p-4 bg-cover bg-center bg-no-repeat flex items-center justify-center'
                        style={{ backgroundImage: `url(${BackgroundImage})` }}
                    >
                        <div className='text-center'>
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
                            <p className="text-white text-lg instrument-sans-medium">Loading games...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
         <div className='w-full flex items-start justify-center bg-[#F9FAFB] relative'>
            <div className='flex flex-col w-full '>
                <div>
                     <Header 
                     title='Trivia Games'
                     />  
                </div>

               <div 
                    className='min-h-screen p-4 bg-cover bg-center bg-no-repeat'
                    style={{ backgroundImage: `url(${BackgroundImage})` }}
               >
                <div className='w-full px-4 py-8'>
                    {/* Home Button - Added at the top */}
                    <div className='mb-6'>
                        <Link
                            to="/"
                            className='inline-flex items-center bg-white hover:bg-gray-100 text-[#069125] border border-[#069125] font-semibold py-2.5 px-6 rounded-lg transition-colors duration-200 instrument-sans-semibold'
                        >
                            ← Back to Home
                        </Link>
                    </div>

                    <div className='text-center lg:text-start mb-8'>
                        <h1 className='text-[20px] md:text-[32px] font-bold text-white mb-4'>
                            QuickCare Quiz Trivia!
                        </h1>
                        <p className='text-sm lg:text-base text-white/90 '>
                            Select any of the  games of your choice, Click the Play button <br  className='hidden lg:block'/>
                             to embark on your exciting quiz adventure!
                        </p>
                    </div>

                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'>
                        {games.map((game) => (
                            <div 
                                key={game.id}
                                className='bg-[#308042B2]/70 text-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col h-full'
                            >
                                {game.image && (
                                    <div className='w-full h-48 bg-gray-200 overflow-hidden rounded-lg'>
                                        <img 
                                            src={game.image} 
                                            alt={game.title}
                                            className='w-full h-full object-cover '
                                        />
                                    </div>
                                )}
                                <div className='py-3 px-2 flex flex-col flex-grow'>
                                    <h3 className='text-xl instrument-sans-bold mb-2'>
                                        {game.title}
                                    </h3>
                                    <p className='text-sm instrument-sans-normal mb-4 line-clamp-3 flex-grow'>
                                        {game.description}
                                    </p>
                                    <Link
                                        to={game.link}
                                        className='w-full bg-[#069125] hover:bg-[#fff] hover:text-black cursor-pointer text-white font-semibold py-2.5 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center instrument-sans-semibold'
                                    >
                                        Play
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
               </div>
            </div>

       </div>
    );
};

export default TriviaGames;